import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from '../router';

export const ONBOARDING_PATH = '/onboarding/';
export const ADD_PUP_SUBPATH = 'addPet';
export const EDIT_PET_SUBPATH = 'editPet';
export const QUIZ_SUBPATH = 'quiz';
export const MEALPREP_SELECTION_SUBPATH = 'mealprep';
export const RECIPES_SELECTION_SUBPATH = 'recipes';
export const ADDONS_SELECTION_SUBPATH = 'extras';
export const RECOMMENDED_PLAN_SUBPATH = 'recommended-plan';
export const GIFT_WITH_PURCHASE_SUBPATH = 'free-gift-selection';
export const QUIZ_ABANDONER_MENU_SUBPATH = 'menu';
export const CHECKOUT_SUBPATH = 'checkout';
export const DELETE_PET_SUBPATH = 'deletePet';
export const INTRO_SLUG = 'intro';

export const PUP_NAME_SLUG = 'petname';
export const PUP_GENDER_SLUG = 'petgender';
export const PUP_BREED_SLUG = 'petbreed';
export const PUP_STATUS_SLUG = 'petstatus';
export const CALORIES_SLUG = 'petweight';
export const ACTIVITY_SLUG = 'petactivity';
export const ALLERGIES_SLUG = 'petallergies';
export const ALLERGY_SELECTION_SLUG = 'allergyselection';
export const POOP_SLUG = 'petpoop';

export const RECIPES_DRY_SLUG = 'baked';
export const RECIPES_FRESH_SLUG = 'fresh';
export const RECIPES_PRODUCT_SLUG = 'product';
export const ABOUT_SLUG = 'about';
export const NUTRITION_SLUG = 'nutrition';
export const ONBOARDING_INTERSTITIAL_SLUG = 'onboarding-interstitial';

export const VALID_SUBPATHS = [
  QUIZ_SUBPATH,
  ADD_PUP_SUBPATH,
  EDIT_PET_SUBPATH,
  MEALPREP_SELECTION_SUBPATH,
  RECOMMENDED_PLAN_SUBPATH,
  RECIPES_SELECTION_SUBPATH,
  ADDONS_SELECTION_SUBPATH,
  CHECKOUT_SUBPATH,
  DELETE_PET_SUBPATH,
  INTRO_SLUG,
  GIFT_WITH_PURCHASE_SUBPATH,
  QUIZ_ABANDONER_MENU_SUBPATH,
];

export const VALID_QUIZ_SLUGS = [
  PUP_NAME_SLUG,
  PUP_GENDER_SLUG,
  PUP_BREED_SLUG,
  PUP_STATUS_SLUG,
  CALORIES_SLUG,
  ACTIVITY_SLUG,
  ALLERGIES_SLUG,
  POOP_SLUG,
  ABOUT_SLUG,
  NUTRITION_SLUG,
  ONBOARDING_INTERSTITIAL_SLUG,
  ALLERGY_SELECTION_SLUG,
];

export const VALID_SLUGS = [
  PUP_NAME_SLUG,
  PUP_GENDER_SLUG,
  PUP_BREED_SLUG,
  PUP_STATUS_SLUG,
  CALORIES_SLUG,
  ACTIVITY_SLUG,
  ALLERGIES_SLUG,
  POOP_SLUG,
  RECIPES_FRESH_SLUG,
  RECIPES_DRY_SLUG,
  RECIPES_PRODUCT_SLUG,
  ABOUT_SLUG,
  NUTRITION_SLUG,
  ONBOARDING_INTERSTITIAL_SLUG,
  INTRO_SLUG,
  ALLERGY_SELECTION_SLUG,
  RECOMMENDED_PLAN_SUBPATH,
  CHECKOUT_SUBPATH,
];

export const RedirectToPathWithPetId = ({ subpath, slug, pet, children }) => {
  return (
    <Redirect
      replace
      to={`/onboarding/${subpath ? `${subpath}/` : ''}${
        slug ? `${slug}/` : ''
      }?pet_id=${pet.id}`}
    >
      {children}
    </Redirect>
  );
};

RedirectToPathWithPetId.propTypes = {
  subpath: PropTypes.oneOf(VALID_SUBPATHS),
  slug: PropTypes.oneOf(VALID_SLUGS),
  children: PropTypes.node.isRequired,
  pet: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

export const RedirectToPathWithoutPetId = ({ subpath, slug, children }) => {
  return (
    <Redirect replace to={`/onboarding/${subpath}/${slug ? `${slug}/` : ''}`}>
      {children}
    </Redirect>
  );
};

RedirectToPathWithoutPetId.propTypes = {
  subpath: PropTypes.oneOf(VALID_SUBPATHS).isRequired,
  slug: PropTypes.oneOf(VALID_SLUGS),
  children: PropTypes.node.isRequired,
};

export const RedirectToDashboard = ({ pet, children }) => {
  return (
    <Redirect replace to={`/account/?pet_id=${pet.id}`}>
      {children}
    </Redirect>
  );
};

RedirectToDashboard.propTypes = {
  children: PropTypes.node.isRequired,
  pet: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};
